import TableReportHelper from "report/helper";

/**
 * Cabeçalho de relatório do TC, sem dependência de parâmetros de cliente
 * (o indicador não possui parâmetros configuráveis).
 */
export default async function tcHeaderLocalizacaoReport(visita, indicador, apontamento) {
    const h = new TableReportHelper(apontamento);
    const coletas = apontamento?.coletas ?? apontamento.georeferencia;
    const IndicadorClass = indicador.constructor;

    const nomeAmostra = `${IndicadorClass.fullName} - ${IndicadorClass.abbrev}`;

    let talhao;

    if (apontamento.talhao.length) {
        let nomeTalhoesOriginal = '';
        let talhoes = apontamento.talhao;

        let orderedTalhoes = talhoes.sort(function (a, b) {
            var nomeA = parseInt(a.nome);
            var nomeB = parseInt(b.nome);

            if (nomeA < nomeB) return -1;
            if (nomeA > nomeB) return 1;
            return 0;
        });

        for (let i = 0; i < orderedTalhoes.length; i++) {
            nomeTalhoesOriginal = nomeTalhoesOriginal + orderedTalhoes[i].nome + ", ";
        }

        let nomeTalhoesModified = nomeTalhoesOriginal.slice(0, -2);
        nomeTalhoesModified = nomeTalhoesModified.replace(/,([^,]*)$/, ' e$1');

        talhao = h.text(nomeTalhoesModified);
    } else {
        talhao = h.textField("talhao.nome");
    }

    const titleAr = [h.title("Talhão"), h.title("Frente")];
    const valueAr = [
        talhao,
        typeof apontamento.frente === "object" ? h.textField("frente.frente") : h.textField("frente"),
    ];

    const arr = titleAr.map((ta, i) => h.row(ta, valueAr[i]));

    const p1content = [
        h.row(h.title("Amostra"), h.text(nomeAmostra)),
        h.row(h.title("Tipo"), h.textField("tipo")),
    ];

    const content = [
        h.panel(p1content, { widths: [100, "*"] }),
        h.panel(arr, { widths: [100, "*"] }),
    ];

    return h.panel([
        h.row(
            h.unbreakable(content),
            await h.locationImageFieldHeaderOnly(coletas)
        ),
    ], { widths: ["*", 210] });
}
